import React from "react"
import { YouTube } from "@mui/icons-material"
import { useNavigate } from "react-router-dom"

import { StatButton } from "react-ui-components/components/StatButton"

import { useNamespacedTranslation } from "../hooks/useNamespacedTranslation"

export const VideoRouteButton: React.FC = () => {
  const navigate = useNavigate()
  const { t } = useNamespacedTranslation(["common"])

  return (
    <StatButton
      link
      icon={<YouTube color="secondary" />}
      label={t("WinViu")}
      onClick={() => {
        navigate("/videos")
      }}
    />
  )
}

export default VideoRouteButton
